/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Children } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { MenuButton } from '@carbon/react';
import { useTranslation } from '../../../../../Utilities/i18n/i18n.js';

var _excluded = ["children", "className", "labelText", "id"];

/**
 * A wrapper around Carbon's MenuButton used to render the actions panel menu.
 */
var ActionsPanel = function ActionsPanel(_ref) {
  var children = _ref.children,
    className = _ref.className,
    labelText = _ref.labelText,
    id = _ref.id,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('cpc--actions-panel-wrap', className),
    "data-floating-menu-container": true,
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "cpc--actions-panel"
  }, /*#__PURE__*/React.createElement(MenuButton, _extends({
    label: labelText || t('Actions'),
    kind: "tertiary",
    size: "md",
    "aria-label": t('Actions')
  }, rest), Children.toArray(children).filter(function (child) {
    if (child.props.visibleBreakpoint === 'small') {
      return null;
    }
    return child;
  }))), /*#__PURE__*/React.createElement("div", {
    className: "cpc--actions-panel-sm"
  }, /*#__PURE__*/React.createElement(MenuButton, _extends({
    label: labelText || t('Actions'),
    kind: "tertiary",
    size: "md",
    "aria-label": t('Actions')
  }, rest), Children.toArray(children))));
};
ActionsPanel.propTypes = {
  /**
   * A set of OverflowMenuItem components to be passed into Carbon's Overflow Menu component.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  /**
   * A custom class name to be applied to the actions panel.
   */
  className: PropTypes.string,
  /**
   * An optional label text for the Actions menu
   */
  labelText: PropTypes.string,
  /**
   * An optional id
   */
  id: PropTypes.string
};
ActionsPanel.displayName = 'ActionsPanel';
var ActionsPanel$1 = ActionsPanel;

export { ActionsPanel$1 as default };
